import styled from 'styled-components';
import { TextInputMasked } from 'components/uikit/Form/TextInputMasked/TextInputMasked';

export const Input = styled(TextInputMasked)`
  --color-icon: var(--color-grey-11_60);
  --color-text: ${(p) =>
    p.isFocused && !p.hasValue ? 'var(--color-grey-11_60)' : 'var(--color-black)'};
`;
